{
  "form": {
    "title": "Забули пароль?",
    "email": {
      "label": "Електронна пошта",
      "placeholder": "maill@mail.zz"
    },
    "submit": {
      "label": "Підтвердити",
      "loading": "Завантаження"
    }
  },

  "success": {
    "title": "Ми надіслали лист на вашу електронну пошту {{email}}",
    "message": "Перейдіть за посиланням у листі, щоб скинути пароль",
    "did-not-receive-email": "Я не отримав(-ла) листа, надіслати новий"
  },
  "error": {
    "failed-to-send-email": "Не вдається надіслати листа. Будь ласка, спробуйте пізніше."
  }
}
